import axios from 'axios'
import { CHAT_ENDPOINTS } from '../config/chatEndpoints'

const normalizeLanguage = (language) => {
  const normalized = String(language || 'EN')
    .trim()
    .toLowerCase()

  return ['en', 'fr', 'nl', 'sw'].includes(normalized)
    ? normalized
    : 'en'
}

export const validateChatAnswer = async ({
  endpoint,
  userAnswer,
  attemptNumber,
  previousAnswers,
  previousData,
  language,
}) => {
  if (!endpoint) {
    throw new Error(
      'No validation API endpoint was configured.',
    )
  }

  const requestBody = {
    userAnswer,
    attemptNumber,
    previousAnswers,
    previousData,
    language: normalizeLanguage(language),
  }

  const response = await axios.post(
    CHAT_ENDPOINTS.validation(endpoint),
    requestBody,
  )

  return response.data
}